(function () {
  const config = document.currentScript && document.currentScript.dataset;
  const pixelId = config && config.pixelId;
  if (!pixelId || window.Shopify?.shop !== 'happy-day-prod.myshopify.com' ||
      window.Shopify.designMode || window.__happyDayOpenAIAdsInitialized) return;
  window.__happyDayOpenAIAdsInitialized = true;

  const sdkUrl = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
  const debug = config.debug === 'true';
  const pending = new Map();
  const sent = new Set();
  let consent = null;
  let configured = false;
  let loading = false;
  let ready = false;

  function warn() {
    if (debug) console.warn('OpenAI Ads: purchase tracking is unavailable.');
  }

  function readConsent() {
    const privacy = window.Shopify.customerPrivacy;
    if (typeof privacy?.marketingAllowed !== 'function') return null;
    return privacy.marketingAllowed() === true &&
      (typeof privacy.saleOfDataAllowed !== 'function' || privacy.saleOfDataAllowed() === true);
  }

  function flush() {
    if (consent !== true || !ready) return;
    pending.forEach((data, eventId) => {
      try {
        window.oaiq('measure', 'order_created', data, { event_id: eventId });
        sent.add(eventId);
        pending.delete(eventId);
      } catch (_) {
        warn();
      }
    });
  }

  function pixelLoaded() {
    loading = false;
    ready = true;
    window.oaiq('consent', consent === true);
    flush();
  }

  function loadPixel() {
    if (ready || loading) return;
    if (typeof window.oaiq !== 'function') {
      const queue = function () { queue.q.push(arguments); };
      queue.q = [];
      window.oaiq = queue;
    }
    if (!configured) {
      window.oaiq('consent', false);
      window.oaiq('init', { pixelId, debug });
      configured = true;
    }
    if (!Array.isArray(window.oaiq.q)) {
      pixelLoaded();
      return;
    }

    let script = document.querySelector('script[src="' + sdkUrl + '"]');
    const ownsScript = !script;
    if (!script) {
      script = document.createElement('script');
      script.async = true;
      script.src = sdkUrl;
    }
    loading = true;
    script.addEventListener('load', pixelLoaded, { once: true });
    script.addEventListener('error', function () {
      loading = false;
      if (ownsScript) script.remove();
      warn();
    }, { once: true });
    if (ownsScript) document.head.appendChild(script);
  }

  function setConsent(allowed) {
    if (allowed === null) return;
    consent = allowed === true;
    if (!consent) pending.clear();
    if (configured) window.oaiq('consent', consent);
    if (consent) {
      loadPixel();
      flush();
    }
  }

  function number(value) {
    if (typeof value !== 'number' && (typeof value !== 'string' || !value.trim())) return null;
    const result = Number(value);
    return Number.isFinite(result) && result >= 0 ? result : null;
  }

  function purchase(message) {
    if (consent === false) return;
    const ecommerce = message.ecommerce;
    if (!ecommerce || !['string', 'number'].includes(typeof ecommerce.transaction_id)) return;
    const orderId = String(ecommerce.transaction_id).trim();
    if (!orderId) return;
    const eventId = 'happyday_purchase_' + orderId;
    if (sent.has(eventId) || pending.has(eventId)) return;

    const currency = String(ecommerce.currency || '').trim().toUpperCase();
    const value = number(ecommerce.value);
    if (!/^[A-Z]{3}$/.test(currency) || value === null) return;
    const digits = new Intl.NumberFormat('en', { style: 'currency', currency })
      .resolvedOptions().maximumFractionDigits;
    const minorUnits = amount => Math.round((amount + Number.EPSILON) * Math.pow(10, digits));
    const amount = minorUnits(value);
    if (!Number.isSafeInteger(amount)) return;

    const data = { type: 'contents', amount, currency };
    if (Array.isArray(ecommerce.items)) {
      data.contents = ecommerce.items.filter(item => item && (item.item_id || item.item_name)).map(item => {
        const content = { content_type: 'product' };
        if (item.item_id) content.id = String(item.item_id);
        if (item.item_name) content.name = String(item.item_name);
        const quantity = number(item.quantity);
        if (Number.isSafeInteger(quantity) && quantity > 0) content.quantity = quantity;
        const price = number(item.price);
        const discount = item.discount == null ? 0 : number(item.discount);
        if (price !== null && discount !== null && discount <= price) {
          const itemAmount = minorUnits(price - discount);
          if (Number.isSafeInteger(itemAmount)) content.amount = itemAmount;
        }
        return content;
      });
    }
    pending.set(eventId, data);
    if (consent === true) loadPixel();
    flush();
  }

  function handleMessage(message) {
    try {
      if (message?.event === 'purchase') purchase(message);
      if (message?.event === 'consent_ready') setConsent(readConsent());
    } catch (_) {
      warn();
    }
  }

  // Preserve GTM's push handler and return value, including when GTM wraps us later.
  const dataLayer = window.dataLayer = window.dataLayer || [];
  const originalPush = dataLayer.push;
  dataLayer.push = function () {
    const result = originalPush.apply(this, arguments);
    Array.prototype.forEach.call(arguments, handleMessage);
    return result;
  };

  document.addEventListener('visitorConsentCollected', function (event) {
    try {
      const detail = event.detail;
      setConsent(typeof detail?.marketingAllowed === 'boolean'
        ? detail.marketingAllowed && detail.saleOfDataAllowed !== false
        : readConsent());
    } catch (_) {
      warn();
    }
  });

  try {
    setConsent(readConsent());
    dataLayer.slice().forEach(handleMessage);
    if (consent === null && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        try {
          setConsent(error ? false : readConsent());
        } catch (_) {
          setConsent(false);
          warn();
        }
      });
    }
  } catch (_) {
    warn();
  }
})();
